module.exports = __webpack_public_path__ + "img/kcc.b6c2611c.png";